// extracted by mini-css-extract-plugin
export var attachment = "_pu-a";
export var emailContainer = "_pu-4";
export var emailContentPaddedContainer = "_pu-b";
export var emailHeader = "_pu-6";
export var emailIframe = "_pu-3";
export var emailInfoIcon = "_pu-9";
export var emailShortenedSummary = "_pu-e";
export var infoDropdown = "_pu-0";
export var infoRowBoundedContent = "_pu-d";
export var internal = "_pu-5";
export var merchant = "_pu-8";
export var messageInputContainer = "_pu-h";
export var normal = "_pu-7";
export var replyCard = "_pu-f";
export var subtleButton = "_pu-1";
export var subtleButtonIconContainer = "_pu-2";
export var toggleViewRepliesButton = "_pu-c";
export var wrappingText = "_pu-g";